const operationErrorMessages: Record<string, string> = {
  CONFIG_INVALID: 'HMRC operation configuration is incomplete.',
  ERPX_API_UNAUTHORIZED: 'ERPx API access failed. Check ERPx API access.',
  ERPX_API_FORBIDDEN: 'ERPx API access failed. Check ERPx API access.',
  ERPX_API_UNREACHABLE: 'ERPx API access failed. Check ERPx API access.',
  ERPX_API_BAD_REQUEST: 'ERPx API rejected the operation request. Check the ERPx API setup.',
  MESSAGEHUB_PUBLISH_FAILED: 'Messaging system problem. The request could not be sent.',
  HMRC_REQUEST_REJECTED: 'HMRC rejected the request. Check HMRC response details.',
  HMRC_RESPONSE_PARSE_FAILED: 'The HMRC response could not be read.',
  OPERATION_UNEXPECTED: 'The operation failed.'
};

export function getOperationErrorMessage(errorCode?: string | null, errorMessage?: string | null): string {
  const existingMessage = errorMessage?.trim();

  if (errorCode === 'HMRC_REQUEST_REJECTED' && existingMessage) {
    return existingMessage;
  }

  if (errorCode && operationErrorMessages[errorCode]) {
    return operationErrorMessages[errorCode];
  }

  return existingMessage || operationErrorMessages.OPERATION_UNEXPECTED;
}